import {Api} from "../Api";
import {Tenant} from "./types";

export class TenantsProvider {

    static list() {
        return Api.GET<Tenant[]>(`tenants`);
    }
}